
import countdown from '../../node_modules/jquery-countdown';

class Countdown {
    constructor() {

        if ($('#event-countdown').length) {

            var eventContainer = $('#event-countdown');

            var eventDay = eventContainer.attr('data-event-day');
            var eventHour = eventContainer.attr('data-event-hour');
            var eventName = eventContainer.attr('data-event-name');

            var myEvent = eventDay + ' ' + eventHour;


            eventContainer.countdown(myEvent, { elapse: true })
                .on('update.countdown', function (event) {

                    if (!event.elapsed) {
                        // countdown
                        var format = '';
                        format += '<span class="block"><span class="value">%H</span> <span class="label">Stunde%!H:n;</span></span> ';
                        format += '<span class="block"><span class="value">%M</span> <span class="label">Minute%!M:n;</span></span> ';
                        format += '<span class="block"><span class="value">%S</span> <span class="label">Sekunde%!S:n;</span></span> ';

                        if (event.offset.totalDays > 0) {
                            format = '<span class="block"><span class="value">%D</span> <span class="label">Tag%!D:e;</span></span> ' + format;
                        }
                        $(this).html(event.strftime(format));

                    } else {
                        // coundown date passed
                        if (event.offset.totalHours < 4) {
                            if (eventName === 'CYCLE TOUR') {
                                $(this).html('').parents('.column').first().find('h3').html('<small>CYCLE TOUR</small>Jetzt zur <a href="[[~112]]#live-streckenkarte">>Live-Streckenkarte</a>!');
                            }
                            if (eventName === 'Firmenstaffel Magdeburg') {
                                $(this).html('').parents('.column').first().find('h3').html('<small>Firmenstaffel Magdeburg</small>Wir freuen uns auf Ihren Besuch!');
                            }

                        } else {
                            if (eventName === 'CYCLE TOUR') {
                                $(this).html('').parents('.column').first().find('h3').html('<small>CYCLE TOUR</small>Die Ergebnisse findest du in Kürze hier!');
                            }
                            if (eventName === 'Firmenstaffel Magdeburg') {
                                $(this).html('').parents('.column').first().find('h3').html('<small>Firmenstaffel Magdeburg</small>Die Ergebnisse finden Sie in Kürze hier!');
                                //$(this).html('').parents('.column').first().find('h3').parent().html('<h3 class="text-center">Ihre Ergebnisse finden Sie ab sofort bei davengo!</h3><p class="text-center"><a href="http://www.davengo.com/event/result/9-firmenstaffel-magdeburg-2017/" class="button" target="_blank">Zu den Ergebnissen</a></a>');
                            }
                        }
                    }
                });
        }
    }
}

export default new Countdown();
